import React from 'react';
import { Box, Button } from '@material-ui/core';

const CWVBanner = ({ planningGroup, showAdvHubBtn }) => {
    const hasClientNames = planningGroup && planningGroup.clientDetails && planningGroup.clientDetails.length > 0;
    const getClientNames = hasClientNames ? planningGroup.clientDetails.map(i => `${i.firstName} ${i.lastName}`).join(', ') : 'N/A';
    const domain = window.location.href.split('/usis/advice/checkout')[0];
    const advisorHubPageLink = `${domain}/usis/advice/admin-tool/advisor-hub`;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                zIndex: '2px',
                borderTop: '2px solid #EA6C23',
                color: 'white',
                background: 'black'
            }}
        >
            <div
                style={{
                    backgroundColor: "#EA6C23",
                    height: showAdvHubBtn ? 'fit-content' : '75px',
                    width: 'fit-content',
                    padding: '12px',
                    fontFamily: 'Nimbus Sans Bold',
                    fontSize: '14px',
                    lineHeight: "36px",
                    textAlign: 'center',
                }}
            >
                Customer Web View <br />
                Household Member(s): {getClientNames}
                {showAdvHubBtn && (
                    <Box>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => window?.location?.replace(advisorHubPageLink)}
                            id='to-advisor-hub'
                            fullWidth
                        >
                            Advisor Hub
                        </Button>
                    </Box>
                )}
            </div>
        </div>
    )
};

export default CWVBanner;
